import Handlebars from "../handlebars/handlebars";
import "./testimonials.css"
import testimonialsHtml from "./testimonials.hbs"

    const testimonials  = document.querySelector('.js--element-testimonials');


    const state = {
        ready: true,
        productName: "",
        rating: 0,
        review: "",
        reviewer: "",
        currentTestimonial: 1,
        totalTestimonials: 0,
        pagination: "",
        productImg: "",
        href: "",
        testimonials: [
            {
                img: "https://spdc-assets.imgix.net/images/testimonial-booklets2.jpg",
                reviewer: "Eric",
                review: "Smartpress has been a reliable partner for us. Their service is consistently excellent, and the paper quality is top-notch. The consistency in paper quality throughout the entire booklet is a testament to their commitment to excellence. Thank you :)",
                href: "/offering/perfect-bound-book",
                productName: "Perfect Bound Booklets",
                rating: 5,
                isCurrent: true
            },
            {
                img: "https://spdc-assets.imgix.net/images/testimonial-flashcards.jpeg",
                reviewer: "Kendall",
                review: "This was my first experience printing with Smartpress and I was very impressed with the experience. There was quick and friendly communication. They really wanted to make sure the product looked the way I expected. Everything arrived in a timely fashion, even between 2 snow storms! I will definitely use Smartpress again!",
                href: "/offering/flashcard-printing",
                productName: "Flashcard Printing",
                rating: 5,
                isCurrent: false
            },
            {
                img: "https://spdc-assets.imgix.net/images/testimonial_static-window-cling.jpeg",
                reviewer: "Christine",
                review: "These were so much better than I ever imagined. We converted a conference room into an arcade for our anniversary week, with glass panels dedicated to 1980s games. We made printing easy by putting small graphics on a single sheet and cut them apart before install. They looked great and we would absolutely do it again!",
                href: "/offering/static-window-clings",
                productName: "Static Window Clings",
                rating: 5,
                isCurrent: false
            },
            {
                img: "https://spdc-assets.imgix.net/images/testimonial-catalog.jpeg",
                reviewer: "Julia",
                review: "My experience with Smartpress was exceptional from start to finish! The colors in the printing of my art catalog were great, precise reproduction and top-quality paper. Additionally, they delivered on time. Really happy and grateful for this work. I highly recommend their services to those seeking quality and professionalism!",
                href: "/offering/catalogs",
                productName: "Catalogs",
                rating: 5,
                isCurrent: false
            }
        ]
    };

    function render(){
        testimonials.innerHTML = testimonialsHtml(state);
    }

    function updateTestimonials(){
        state.pagination = state.currentTestimonial + "/" + state.testimonials.length;
        state.href = state.testimonials[(state.currentTestimonial - 1)].href;
        state.productName = state.testimonials[(state.currentTestimonial - 1)].productName;
        state.review = state.testimonials[(state.currentTestimonial - 1)].review;
        state.reviewer = state.testimonials[(state.currentTestimonial - 1)].reviewer;
        state.productImg = state.testimonials[(state.currentTestimonial - 1)].img;
        state.rating = state.testimonials[state.currentTestimonial-1].rating;
        render();
    };

    function clearTestimonailsIndicators(){
        state.testimonials.forEach(e => {
            e.isCurrent = false;
        })
    }

    function next(){
        if(state.currentTestimonial === state.testimonials.length){
            state.currentTestimonial = 1;
            clearTestimonailsIndicators();
            state.testimonials[0].isCurrent = true;
        } else {
            state.currentTestimonial++;
            clearTestimonailsIndicators();
            state.testimonials[(state.currentTestimonial - 1)].isCurrent = true;
        }
        updateTestimonials();
    };

    function prev(){
        if(state.currentTestimonial === 1 ){
            state.currentTestimonial = state.testimonials.length;
            clearTestimonailsIndicators();
            state.testimonials[state.testimonials.length - 1].isCurrent = true;
        } else {
            state.currentTestimonial--;
            clearTestimonailsIndicators();
            state.testimonials[(state.currentTestimonial - 1)].isCurrent = true;
        }
        updateTestimonials();
    };

    function enableUI(){
        document.querySelector('.js--element-testimonials').addEventListener('click', handleClicks)
    }

    function handleClicks(e){
        if (e.target.matches('.js--action-testimonialNext')) {
            next();
            return;
        }
        if (e.target.matches('.js--action-testimonialPrev')) {
            prev();
            return;
        }
    }

    function initTestimonials(){
        state.ready = true;
        state.pagination = state.currentTestimonial + "/" + state.testimonials.length;
        state.href = state.testimonials[(state.currentTestimonial - 1)].href;
        state.productName = state.testimonials[0].productName;
        state.review = state.testimonials[0].review;
        state.reviewer = state.testimonials[0].reviewer;
        state.productImg = state.testimonials[0].img;
        state.rating = state.testimonials[0].rating;
        render();
        enableUI();
    };

    initTestimonials();

